import React from 'react';
import Gravatar from 'react-gravatar';
import { type ActiveUser } from '@bbkAdminRedux/app/reducers';

export const ProfileImage: React.FC<{
  user: ActiveUser;
}> = ({ user }) => {
  if (user?.details?.image_url) {
    return (
      <img
        className="tw-h-5 tw-w-5 tw-rounded-full"
        src={user.details.image_url}
        alt={user.details.display_name}
      />
    );
  }
  return (
    <Gravatar
      className="tw-h-5 tw-w-5 tw-rounded-full"
      email={user.email}
      size={18}
      rating="pg"
      default="mp"
    />
  );
};
